import {createSlice} from "@reduxjs/toolkit";

interface WidgetConfigTypes {
  formats: any
  tenant: string
  googleMapConfig: {
    mapsAPIKey: string,
    placesLookupCountry: string,
    mapId?: string,
  },
  selectedFormat: any,
  genders: any,
  widgetParentWidth: number
  language: string
  allFormatsIcon: string | null
  timeZone: string
  days: any
  inclusions: any
  breakpointClass: string
  floatingBarWidth: number
  hideCompetitionFees: null | boolean
}

const initialState: WidgetConfigTypes = {
  formats: null,
  tenant: '',
  googleMapConfig: {
    mapsAPIKey: '',
    placesLookupCountry: '',
    mapId: ''
  },
  selectedFormat: null,
  genders: null,
  widgetParentWidth: 0,
  language: '',
  allFormatsIcon: null,
  timeZone: '',
  days: null,
  inclusions: null,
  breakpointClass: '',
  floatingBarWidth: 0,
  hideCompetitionFees: null
}

const widgetConfigurationSlice = createSlice({
  name: 'Widget Configuration Slice',
  initialState,
  reducers: {
    setConfigurationSettings(state, actions) {
      state.formats = actions.payload.formats;
      state.googleMapConfig= actions.payload.google;
      state.genders = actions.payload.genders;
      state.language = actions.payload.language;
      state.tenant = actions.payload.tenant;
      state.tenant = actions.payload.tenant;
      state.allFormatsIcon = actions.payload.allFormatsIcon;
      state.timeZone = actions.payload.timeZone;
      state.days = actions.payload.days;
      state.inclusions = actions.payload.inclusions;
      state.hideCompetitionFees = actions.payload.hasOwnProperty("hideCompetitionFees") ? actions.payload.hideCompetitionFees : null; 
    },
    setWidgetParentWidth(state, actions) {
      state.widgetParentWidth = actions.payload.parentWidth;
      state.breakpointClass = actions.payload.breakpointClass;
    },
    setFloatingBarWidth(state, actions) {
      state.floatingBarWidth = actions.payload;
    }
  },
})

export const widgetConfigurationSliceActions = widgetConfigurationSlice.actions;

export default widgetConfigurationSlice.reducer;
